import PropTypes from 'prop-types';
import Highlight from '@App/model/similarSearch/Highlight';
import InProject from '@App/model/version/InProject';

export const TrackVersionPropType = PropTypes.shape({
    reference: PropTypes.string.isRequired,
    label: PropTypes.string,
    waveformUrl: PropTypes.string,
    duration: PropTypes.number.isRequired,
    audioFileUrl: PropTypes.string.isRequired,
    main: PropTypes.bool.isRequired,
    availableForSimilarSearch: PropTypes.bool.isRequired,
    adminEditUrl: PropTypes.string,
    track: PropTypes.shape({
        reference: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        nbVersions: PropTypes.number.isRequired,
        createdAt: PropTypes.string.isRequired,
        album: PropTypes.shape({
            reference: PropTypes.string.isRequired,
            coverAsThumbnail: PropTypes.string.isRequired,
        }),
    }).isRequired,
    highlights: PropTypes.arrayOf(Highlight),
    projects: PropTypes.arrayOf(InProject),
});
